import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import { fetchOrders } from "../../actions/orderActions"

class KanbanPage extends React.Component {

  componentWillMount(){
    this.props.fetchOrders();
  }

  showOrder = el => {
    if (!el.currentTarget.id) {
      return;
    }
    this.context.router.push('/order/edit?id=' + el.currentTarget.id);
  }

  render() {
    if(isEmpty(this.props.places)
      || isEmpty(this.props.comps)
      || isEmpty(this.props.orders)
      || isEmpty(this.props.sttss)
      || isEmpty(this.props.empls)
    ){
      return(<div>Не загружены данные</div>);
    }
    const { orders, comps, places, sttss, empls, filter } = this.props;
    const lists = {};
    for (var i = 0; i < orders.length; i++) {
      if (!lists[orders[i].order_stts_id]) lists[orders[i].order_stts_id] = [];
      lists[orders[i].order_stts_id].push(orders[i]);
    }
    return (
      <div className="full-height">
        <div className="kanban-container">
          {filter.map(el => {
            return(
              <div className="kanban-list" key={el}>
                <div className="kanban-list-header">
                  <div
                    className="kanban-list-header-marker"
                    style={{backgroundColor: sttss[el].stts_color_id}}
                  />
                  {sttss[el].stts_desc}
                </div>
                {lists[el].map(order => {
                  return(
                    <div
                      key={order.order_id}
                      className="kanban-card"
                      id={order.order_id}
                      onClick={this.showOrder}
                    >
                      <div style={{float: 'right'}}>
                        {moment(order.order_edate).format('L')}
                      </div>
                      {order.order_num} -{" "}
                      {(
                        empls.find(el => el.user_id === order.order_empl2)
                        || {}
                      ).user_fname}<br />
                      <b>{order.order_desc}</b><br />
                      {comps[order.order_comp_id].comp_desc}<br />
                      <i>{places[order.order_place_id].place_desc}</i><br />
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

KanbanPage.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapOrdersToProps(store) {
  return {
    orders: store.orders.data,
    filter: store.orders.filter,
    places: store.places.data,
    comps: store.comps.data,
    empls: store.empls,
    sttss: store.sttss.data
  }
}

export default connect(mapOrdersToProps, { fetchOrders })(KanbanPage);



// WEBPACK FOOTER //
// ./src/components/kanban/KanbanPage.js